import { Dashboard } from "../components/dashboard/Dashboard";
import {
  CUSTOMER,
  CUSTOMER_CONVERSATION,
  CUSTOMER_ORDER,
} from "../constants/routes";
import { Customer } from "../pages/customer/Customer";
import { CustomerConversation } from "../pages/customer/CustomerConversation";
import { CustomerOrder } from "../pages/customer/CustomerOrder";
import { useSelectedRouteParams } from "./useSelectedRouteParams";

export function CustomerRoute() {
  const { connectionId } = useSelectedRouteParams(CUSTOMER);

  return (
    <Dashboard
      width={1200}
      parentComponent={<Customer connectionId={connectionId} />}
      parentPart="1fr"
      childPart="minmax(500px,33%)"
      defaultChild={CUSTOMER_CONVERSATION.href({ connectionId })}
    />
  );
}

export function CustomerConversationRoute() {
  const { connectionId } = useSelectedRouteParams(CUSTOMER_CONVERSATION);

  return <CustomerConversation connectionId={connectionId} />;
}

export function CustomerOrderRoute() {
  const { connectionId, orderId } = useSelectedRouteParams(CUSTOMER_ORDER);

  return <CustomerOrder connectionId={connectionId} orderId={orderId} />;
}
